// @flow
import React, { useState, useEffect } from 'react'
import { reorder } from '@utils/array'
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd'

interface Props {
  ids: string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
  isSortable: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdate: (orders: Array<any>) => void
}

const Sortable = ({ ids, children, isSortable, onUpdate }: Props) => {
  const [ items, setItems ] = useState(ids)
  useEffect(() => {
    let newItems
    if (ids.length > items.length) {
      const missingIds = ids.filter((id) => !items.includes(id))
      newItems = [ ...items, ...missingIds ]
    }
    else {
      newItems = items.filter((id) => ids.includes(id))
    }
    setItems(newItems)
    onUpdate(newItems)
  }, [ ids.length ])

  const onDragEnd = ({ source, destination }: DropResult) => {
    // dropped outside the list
    if (!destination) {
      return
    }

    const newItems = reorder(items, source.index, destination.index)
    setItems(newItems)
    onUpdate(newItems)
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(dropProvided) => (
          <div ref={dropProvided.innerRef}>
            {items.map((id, index) => (
              <Draggable
                key={id}
                draggableId={id}
                index={index}
                isDragDisabled={!isSortable}
              >
                {(dragProvided, dragSnapshot) => (
                  <div
                    ref={dragProvided.innerRef}
                    {...dragProvided.draggableProps}
                  >
                    {children({
                      index,
                      id,
                      dragging: dragSnapshot.isDragging,
                      dragHandleProps: dragProvided.dragHandleProps,
                    })}
                  </div>
                )}
              </Draggable>
            ))}
            {dropProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

Sortable.defaultProps = {}

export default Sortable
